
import MillieApi from 'app/apis/millie';
import AuthSlx   from 'app/selectors/auth';

const Types = {
  UPDATE: 'ACCOUNT_UPDATE',
  PARTIAL_UPDATE: 'ACCOUNT_PARTIAL_UPDATE',
  LOAD_PAGE_NEW_PW: 'ACCOUNT_LOAD_PAGE_NEW_PW',
  SET_NEW_PW: 'ACCOUNT_SET_NEW_PW',
  SET_PREFS: 'ACCOUNT_SET_PREFS',
};

const Actions = {

  update: ({firstName, lastName, postalCode, email, avatarPath, private: isPrivate}) => {
    const promise = MillieApi.accountUpdate({firstName, lastName, postalCode, email, avatarPath, private: isPrivate});
    return { type: Types.UPDATE, promise, email };
  },

  partialUpdate: (attrs) => {
    const promise = MillieApi.accountPartialUpdate(attrs);
    return { type: Types.PARTIAL_UPDATE, promise };
  },

  loadPageNewPw: (location) => (dispatch, getState) => {
    const promise = Promise.resolve();
    return dispatch({type: Types.LOAD_PAGE_NEW_PW, promise});
  },

  setNewPassword: (pw, pw2) => {
    const promise = MillieApi.accountSetNewPassword(pw, pw2);
    return {type: Types.SET_NEW_PW, promise};
  },

  setPrefs: (prefs) => (dispatch, getState) => {
    const currentUser = AuthSlx.currentUser(getState());
    const promise = currentUser ? MillieApi.accountSetPrefs(prefs) : Promise.resolve();
    const key = Math.random();
    return {type: Types.SET_PREFS, promise, prefs, key};
  },

};

export {
  Types,
};

export default Actions;
